(function (window, document) {
  'use strict';

  if (window.LovireaDeliveryPromise && window.LovireaDeliveryPromise.refresh) {
    window.LovireaDeliveryPromise.refresh();
    return;
  }

  var configElement = document.getElementById('LovireaDeliveryPromiseConfig');
  var defaultConfig = {
    cutoff: '23:00',
    timezone: 'Europe/Amsterdam',
    countdownEnabled: true,
    countdownMinutes: 300,
    shippingDays: '1,2,3,4,5',
    deliveryDays: '1,2,3,4,5,6',
    weekendDelivery: true,
    processingDays: 0,
    excludeDutchHolidays: true,
    excludedDates: '',
    fallback: 'Nu besteld, overmorgen in huis'
  };
  var config = defaultConfig;
  var timerId = null;
  var observer = null;
  var refreshQueued = false;
  var testLocalTime = null;

  try {
    config = Object.assign({}, defaultConfig, JSON.parse(configElement ? configElement.textContent : '{}'));
  } catch (error) {
    config = defaultConfig;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function formatCountdown(totalSeconds) {
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    if (hours > 0) return hours + 'u ' + minutes + 'm ' + seconds + 's';
    if (minutes > 0) return minutes + 'm ' + seconds + 's';
    return seconds + 's';
  }

  function isoDate(date) {
    return date.year + '-' + pad(date.month) + '-' + pad(date.day);
  }

  function dateFromParts(parts) {
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day)
    };
  }

  function addDays(date, amount) {
    var utcDate = new Date(Date.UTC(date.year, date.month - 1, date.day + amount, 12));
    return {
      year: utcDate.getUTCFullYear(),
      month: utcDate.getUTCMonth() + 1,
      day: utcDate.getUTCDate()
    };
  }

  function weekday(date) {
    var day = new Date(Date.UTC(date.year, date.month - 1, date.day, 12)).getUTCDay();
    return day === 0 ? 7 : day;
  }

  function parseDays(value) {
    var days = String(value || '')
      .split(/[^0-9]+/)
      .map(Number)
      .filter(function (day) { return day >= 1 && day <= 7; });
    return Array.from(new Set(days));
  }

  function parseExcludedDates(value) {
    return new Set(
      String(value || '')
        .split(/[\s,;]+/)
        .map(function (date) { return date.trim(); })
        .filter(function (date) { return /^\d{4}-\d{2}-\d{2}$/.test(date); })
    );
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return { year: year, month: month, day: day };
  }

  function dutchPublicHolidays(year) {
    var holidays = new Set();
    var easter = easterSunday(year);
    var kingsDay = { year: year, month: 4, day: 27 };
    holidays.add(year + '-01-01');
    holidays.add(isoDate(addDays(easter, -2)));
    holidays.add(isoDate(easter));
    holidays.add(isoDate(addDays(easter, 1)));
    holidays.add(isoDate(kingsDay));
    if (weekday(kingsDay) === 7) holidays.add(year + '-04-26');
    holidays.add(year + '-05-05');
    holidays.add(isoDate(addDays(easter, 39)));
    holidays.add(isoDate(addDays(easter, 49)));
    holidays.add(isoDate(addDays(easter, 50)));
    holidays.add(year + '-12-25');
    holidays.add(year + '-12-26');
    return holidays;
  }

  function parseCutoff(value) {
    var match = String(value || '').match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    var hour = Number(match[1]);
    var minute = Number(match[2]);
    if (hour > 23 || minute > 59) return null;
    return { hour: hour, minute: minute, label: pad(hour) + ':' + pad(minute) };
  }

  function parseLocalTime(value) {
    var match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!match) return null;
    var parts = {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
      hour: Number(match[4]),
      minute: Number(match[5]),
      second: Number(match[6] || 0)
    };
    var normalized = addDays(dateFromParts(parts), 0);
    if (
      normalized.year !== parts.year ||
      normalized.month !== parts.month ||
      normalized.day !== parts.day ||
      parts.hour > 23 ||
      parts.minute > 59 ||
      parts.second > 59
    ) return null;
    return parts;
  }

  function zonedParts(date, timezone) {
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
    var values = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return {
      year: values.year,
      month: values.month,
      day: values.day,
      hour: values.hour,
      minute: values.minute,
      second: values.second
    };
  }

  function formatDeliveryDate(date) {
    var utcDate = new Date(Date.UTC(date.year, date.month - 1, date.day, 12));
    return new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(utcDate);
  }

  function findOnOrAfter(startDate, predicate) {
    var candidate = startDate;
    for (var index = 0; index < 370; index += 1) {
      if (predicate(candidate)) return candidate;
      candidate = addDays(candidate, 1);
    }
    return null;
  }

  function calculate(parts) {
    try {
      var cutoff = parseCutoff(config.cutoff);
      var shippingDays = parseDays(config.shippingDays);
      var deliveryDays = parseDays(config.deliveryDays);
      var excludedDates = parseExcludedDates(config.excludedDates);
      var holidayCache = {};
      var processingDays = Math.max(0, Math.min(5, Number(config.processingDays) || 0));
      var countdownMinutes = Math.max(60, Math.min(1380, Number(config.countdownMinutes) || 300));
      var today = dateFromParts(parts);

      if (!cutoff || shippingDays.length === 0 || deliveryDays.length === 0) {
        return config.fallback;
      }

      function isExcluded(date) {
        if (excludedDates.has(isoDate(date))) return true;
        if (!config.excludeDutchHolidays) return false;
        if (!holidayCache[date.year]) holidayCache[date.year] = dutchPublicHolidays(date.year);
        return holidayCache[date.year].has(isoDate(date));
      }

      function isShippingDay(date) {
        return shippingDays.indexOf(weekday(date)) !== -1 && !isExcluded(date);
      }

      function isDeliveryDay(date) {
        var day = weekday(date);
        if (!config.weekendDelivery && day >= 6) return false;
        return deliveryDays.indexOf(day) !== -1 && !isExcluded(date);
      }

      var afterCutoff = parts.hour * 60 + parts.minute >= cutoff.hour * 60 + cutoff.minute;
      var canShipToday = !afterCutoff && isShippingDay(today);
      var dispatchDate = canShipToday
        ? today
        : findOnOrAfter(addDays(today, 1), isShippingDay);

      if (!dispatchDate) return config.fallback;

      for (var processIndex = 0; processIndex < processingDays; processIndex += 1) {
        dispatchDate = findOnOrAfter(addDays(dispatchDate, 1), isShippingDay);
        if (!dispatchDate) return config.fallback;
      }

      var deliveryDate = findOnOrAfter(addDays(dispatchDate, 1), isDeliveryDay);
      if (!deliveryDate) return config.fallback;

      if (
        canShipToday &&
        processingDays === 0 &&
        isoDate(deliveryDate) === isoDate(addDays(today, 1))
      ) {
        var secondsUntilCutoff =
          cutoff.hour * 3600 + cutoff.minute * 60 -
          (parts.hour * 3600 + parts.minute * 60 + (parts.second || 0));
        if (
          config.countdownEnabled &&
          secondsUntilCutoff > 0 &&
          secondsUntilCutoff <= countdownMinutes * 60
        ) {
          return 'Bestel binnen ' + formatCountdown(secondsUntilCutoff) + ' voor levering morgen';
        }
        return 'Voor ' + cutoff.label + ' besteld, morgen in huis';
      }

      return 'Nu besteld, ' + formatDeliveryDate(deliveryDate) + ' in huis';
    } catch (error) {
      return config.fallback;
    }
  }

  function currentParts() {
    if (testLocalTime) return testLocalTime;
    return zonedParts(new Date(), config.timezone);
  }

  function refresh(root) {
    var text;
    try {
      text = calculate(currentParts());
    } catch (error) {
      text = config.fallback;
    }

    var scope = root && root.querySelectorAll ? root : document;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-delivery-promise]'));
    if (scope.matches && scope.matches('[data-delivery-promise]')) nodes.unshift(scope);
    nodes.forEach(function (node) {
      if (node.textContent !== text) node.textContent = text;
    });
    return text;
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function () {
      refreshQueued = false;
      refresh();
    });
  }

  function scheduleNextUpdate() {
    if (timerId) window.clearTimeout(timerId);
    var currentText = refresh();
    var countdownActive = currentText.indexOf('Bestel binnen ') === 0;
    var interval = countdownActive ? 1000 : 60000;
    var delay = interval - (Date.now() % interval) + 50;
    timerId = window.setTimeout(function tick() {
      scheduleNextUpdate();
    }, delay);
  }

  var api = {
    version: '1.0.0',
    refresh: refresh,
    preview: function (localDateTime) {
      var parts = parseLocalTime(localDateTime);
      return parts ? calculate(parts) : config.fallback;
    },
    previewInstant: function (isoInstant) {
      var instant = new Date(isoInstant);
      return Number.isNaN(instant.getTime()) ? config.fallback : calculate(zonedParts(instant, config.timezone));
    },
    setTestNow: function (localDateTime) {
      testLocalTime = parseLocalTime(localDateTime);
      return refresh();
    },
    clearTestNow: function () {
      testLocalTime = null;
      return refresh();
    }
  };

  window.LovireaDeliveryPromise = api;

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });

  if (document.body && window.MutationObserver) {
    observer = new MutationObserver(queueRefresh);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  scheduleNextUpdate();
})(window, document);
